// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xngc","type":"styles_type__21unA","choices":"styles_choices__3ZxWJ"};